import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import {
  CustomClimateImportResult,
  EpwLocationMetadata,
  ImportCustomClimateRequest,
  UpdateCustomClimateRequest,
} from '../models/custom-climate.model';

@Injectable({ providedIn: 'root' })
export class CustomClimateService {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${inject(ApiUrlInjectionToken)}/ea-custom-climates`;

  previewMetadata(file: File): Observable<EpwLocationMetadata | null> {
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<EpwLocationMetadata | null>(`${this.endpoint}/preview`, fd);
  }

  import(file: File, request: ImportCustomClimateRequest): Observable<CustomClimateImportResult> {
    return this.http.post<CustomClimateImportResult>(this.endpoint, this.buildMultipart(file, request));
  }

  update(id: string, file: File | null, request: UpdateCustomClimateRequest): Observable<CustomClimateImportResult> {
    return this.http.patch<CustomClimateImportResult>(`${this.endpoint}/${id}`, this.buildMultipart(file, request));
  }

  delete(id: string, energyAnalysisId: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`, { params: { energyAnalysisId } });
  }

  getBlockingAnalyses(id: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.endpoint}/${id}/blocking-analyses`);
  }

  private buildMultipart(file: File | null, request: object): FormData {
    const fd = new FormData();
    if (file) fd.append('file', file);
    fd.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    return fd;
  }
}
